import { SlugifiedFilterItemWithValues } from 'services/providers/bapi/entities/filters/normalize'
import {
  FilterGroupItem,
  isFilterGroup,
} from 'services/providers/bapi/entities/filters/types'
import {
  CATEGORY_SHOP_FILTER_SIZES_GROUP_NAME_CLOTHING,
  CATEGORY_SHOP_FILTER_SIZES_GROUP_NAME_DEFAULT,
  CATEGORY_SHOP_FILTER_SIZES_GROUP_NAME_SHOES,
} from './transformFilters'

export const isFilterGroupWithoutValues = (filterGroup: FilterGroupItem) => {
  if (isFilterGroup(filterGroup)) {
    filterGroup.filters = filterGroup.filters.filter(
      filter => filter.values.length !== 0 || filterIsHeadline(filter),
    )

    if (filterGroup.filters.length === 0) {
      return true
    }
  } else if (
    filterGroup.values.length === 0 &&
    !filterIsHeadline(filterGroup)
  ) {
    return true
  }

  return false
}

const filterIsHeadline = (filter: SlugifiedFilterItemWithValues) => {
  return (
    filter.slug === CATEGORY_SHOP_FILTER_SIZES_GROUP_NAME_CLOTHING ||
    filter.slug === CATEGORY_SHOP_FILTER_SIZES_GROUP_NAME_SHOES ||
    filter.slug === CATEGORY_SHOP_FILTER_SIZES_GROUP_NAME_DEFAULT
  )
}
